export const MOVE_PIECE = "MOVE_PIECE";
export const CAPTURE_PIECE = "CAPTURE_PIECE";
export const CHANGE_SIDE = "CHANGE_SIDE";
export const INITIAL = "INITIAL";
export const CHANGE_BOARD = "CHANGE_BOARD";
